export class SignInModel {
  user!: string | null;
  password!: string | null;
  recaptcha!: string | null;
}
